export default __webpack_public_path__ + "static/media/discord.a83a0ded.svg";